<ion-header>
  <ion-toolbar>
    <ion-title *ngIf="headerInput().length === 0">Scan or enter per piece tag to get details</ion-title>
    <ion-row *ngIf="headerInput().length > 0" class="ion-padding-horizontal">
      <ion-col *ngFor="let bctx of headerInput()">
        <div class="header-text">
          {{ bctx.label }}
        </div>
        <div>
          {{ bctx.value }}
        </div>
      </ion-col>
    </ion-row>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-row class="ion-justify-content-end ion-padding-vertical">
    <ng-container *ngIf="isPerPieceApp">
      <ion-input type="text" placeholder="Enter Tag ID" [(ngModel)]="displayTag" class="ion-margin-end"></ion-input>
      <ion-button (click)="getTagDetails(displayTag)">
        <ion-icon name="search"></ion-icon>
        <ion-label>Search</ion-label>
      </ion-button>
      <ion-button color="warning" (click)="scanTag()">
        <ion-icon name="scan"></ion-icon>
        <ion-label>Scan</ion-label>
      </ion-button>
      <ion-button color="danger" (click)="clear()"> Clear </ion-button>
    </ng-container>

    <ion-button color="primary" (click)="sync()"> Sync</ion-button>
  </ion-row>
  <ng-container *ngIf="selectedBctxIno().length > 0; else noBctxSelected">
    <ui-table [zTableModel]="tableModel()" (onRowAction)="onRowAction($event)"></ui-table>
  </ng-container>

  <ng-template #noBctxSelected>
    <div class="ion-text-center">
      <p>No BCTX selected, Select bctx from home screen or scan a tag</p>
    </div>
  </ng-template>
</ion-content>
